export default "__VITE_ASSET__13ad3572__"